/**
 * Pre-compiled localized messages for Calendar component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import calendarMessages_en from "./intl/en";
import calendarMessages_de from "./intl/de";
import calendarMessages_es from "./intl/es";
import calendarMessages_fr from "./intl/fr-FR";
import calendarMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const calendarMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(calendarMessages_en),
  de: normalizeMessages(calendarMessages_de),
  es: normalizeMessages(calendarMessages_es),
  "fr-FR": normalizeMessages(calendarMessages_fr),
  "pt-BR": normalizeMessages(calendarMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for Calendar component
 */
export type CalendarMessageKey =
  | "nextMonth"
  | "nextYear"
  | "previousMonth"
  | "previousYear";
